export default __webpack_public_path__ + "static/media/website.67dc8f62.gif";